import { BetGroupType } from '@bpos';
import { TeaserDetails } from '@bpos/common/bet-placement';
import { BetSlip } from '@bpos/v2/bet-placement';
import { BposOddsConverterService, OddsOperations, emptyOdds } from '@frontend/sports/odds/feature';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { IBetslipState } from '../../../../../base/store/state';
import { BetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { PriceType } from '../../../../../core/picks/pick-models';
import { ISlipPick } from '../../../../bet-generation/models';
import { IBetPicks } from '../../../models';
import { IPickRequestFactoryMapper } from './ipick-request-mapper-factory';
import { IPickRequestMapper } from './pick-request.models';

export class GroupPickRequestMapper implements IPickRequestMapper {
    constructor(
        private bposOddsConverterService: BposOddsConverterService,
        private userOddsFormatSettingsService: UserOddsFormatSettingsService,
        private picksMapperFactory: IPickRequestFactoryMapper,
    ) {}

    appendBetDetails(
        betslip: BetSlip,
        slipPick: ISlipPick<BetslipGroupPick>,
        index: number,
        requestPicks: IBetPicks,
        state?: IBetslipState | undefined,
    ): { nextIndex: number } {
        const betsIndexes = this.appendIndividualLegsInfo(betslip, slipPick, index, requestPicks, state);
        this.appendGroupInfo(betslip, slipPick, betsIndexes, requestPicks);

        return { nextIndex: betsIndexes[betsIndexes.length - 1] + 1 };
    }

    private appendIndividualLegsInfo(
        betslip: BetSlip,
        slipPick: ISlipPick<BetslipGroupPick>,
        index: number,
        requestPicks: IBetPicks,
        state?: IBetslipState | undefined,
    ): number[] {
        const picks = slipPick.pick.getLegs();
        const betIndexes: number[] = [];
        let currentIndex = index;
        picks.forEach((pick) => {
            const mapper = this.picksMapperFactory.create(pick);
            const betAdded = mapper.appendBetDetails(
                betslip,
                {
                    eachWayInfo: null,
                    isBanker: false,
                    isStartingPrice: false,
                    isXCast: false,
                    pick,
                    price: {
                        type: PriceType.NoPrice,
                        nativeOdds: emptyOdds,
                    },
                    priceIds: pick.prices.map((t) => t.id),
                },
                currentIndex,
                requestPicks,
                state,
                { isInGroup: true },
            );
            betIndexes.push(currentIndex);
            currentIndex = betAdded.nextIndex;
        });

        return betIndexes;
    }

    private appendGroupInfo(betslip: BetSlip, slipPick: ISlipPick<BetslipGroupPick>, betsIndexes: number[], requestPicks: IBetPicks) {
        const index = Object.keys(requestPicks.groups).length + 1;
        betslip.betGroups.push({
            betGroupType: BetGroupType.Ogp,
            bets: betsIndexes,
            oddsFormat: OddsOperations.convertToBposOddsFormat(this.userOddsFormatSettingsService.oddsFormat),
            index,
            userExpectedOdds: this.bposOddsConverterService.convertToBposOdds(slipPick.price.nativeOdds),
            teaserDetails: {} as unknown as TeaserDetails,
        });
        requestPicks.groups[index] = slipPick.pick;
    }
}
